import { Modal, Panel } from '@elotech/components';
import React, { useRef } from 'react';

import styles from '../arquivo/visualizador.module.css';
import { DocumentViewer } from './DocumentViewer';

type Props = Omit<React.ComponentProps<typeof DocumentViewer>, 'introRef'> & {
  onClose: () => void;
  returnFocusRef?: React.RefObject<HTMLElement>;
};

export const DocumentViewerModal: React.FC<Props> = ({
  onClose,
  returnFocusRef,
  ...viewerProps
}) => {
  const introRef = useRef<HTMLDivElement>(null);

  return (
    <Modal
      onClose={onClose}
      ariaLabel="Visualizador de documentos"
      initialFocusRef={introRef}
      returnFocusRef={returnFocusRef}
      trapFocus
    >
      <Panel className={styles.viewer} title="Visualizador de documentos">
        <DocumentViewer {...viewerProps} introRef={introRef} />
      </Panel>
    </Modal>
  );
};
